import React from 'react'
import ReactDOM from 'react-dom/client'
// Self-hosted type: Barlow for values, headings and running copy; Barlow
// Condensed for printed labels and stamps.
import '@fontsource/barlow/400.css'
import '@fontsource/barlow/500.css'
import '@fontsource/barlow/600.css'
import '@fontsource/barlow/700.css'
import '@fontsource/barlow-condensed/500.css'
import '@fontsource/barlow-condensed/600.css'
import '@fontsource/barlow-condensed/700.css'
import { AppProviders } from './contexts'
import AppRouter from './routes'
import './index.css'
import { startErrorTracking } from './instrument'

startErrorTracking()

// After a deploy, a tab opened on the previous build asks for page chunks
// that no longer exist (the SPA rewrite answers with index.html), so every
// lazy page it opens fails. Reload once to pick up the new build; a second
// failure inside a minute falls through to the route's error screen.
window.addEventListener('vite:preloadError', event => {
  const KEY = 'rentra:chunk-reload'
  try {
    const last = Number(sessionStorage.getItem(KEY)) || 0
    if (Date.now() - last < 60_000) return
    sessionStorage.setItem(KEY, String(Date.now()))
  } catch {
    // Storage blocked: no way to stop a reload loop, so do not reload.
    return
  }
  event.preventDefault()
  window.location.reload()
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </React.StrictMode>
)
